import { Container } from "./styles";
import externalLink from "../../assets/external-link.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Project() {
  return (
    <Container id="project">
      <h2>My Projects</h2>
      <div className="projects">

      <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><title>Folder</title> <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path> </svg>
              <div className="project-links">
                <a href="https://www.twistbioscience.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" /></a>
              </div>
            </header>
            <div className="body">
              <h3>Full Stack Development (Twist Biosciences)</h3>
              <p>• Developed and deployed a full-stack solution using ReactJS and Django Rest Framework to manage critical data workflows.<br />
              • API Development: Designed robust Python/Django RESTful APIs to ensure seamless data exchange and scalability within the system. <br />
              • Database Integration: Implemented and managed the application's persistent data layer using PostgreSQL for reliable data storage and retrieval.<br />
              • State Management: Optimized the user experience and application performance by utilizing Redux for predictable and centralized state management on the frontend. <br />
              • Performed CRUD operations and Manipulated data using Postgres.</p>
            </div>
            <footer> <ul className="tech-list"><li>Python</li> <li>React</li> <li>DjangoREST</li> <li>Postgres</li></ul> </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://alvio.io/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" /></a>
              </div>
            </header>
            <div className="body">
              <h3>Full Stack AI Development (Alvio.io)</h3>
              <p>
              •   Developed and enhanced an AI-powered application platform using ReactJS and FastAPI, enabling users to build and interact with intelligent applications through natural language.<br />
              •   RAG Implementation: Designed and integrated Retrieval-Augmented Generation (RAG) pipelines to provide context-aware responses by retrieving relevant information from application-specific data sources.<br />
              •   API Development: Built scalable and modular FastAPI services for AI workflows, application management, data processing, and seamless communication between the frontend and AI services.<br />
              •   Frontend Development: Developed responsive ReactJS interfaces for configuring AI applications, managing workflows, and interacting with AI-powered features.<br />
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Python</li>
                <li>FastAPI</li>
                <li>React</li>
                <li>RAG</li>
                <li>Agentic AI</li>
                <li>LLM</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://paathz.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" /></a>
              </div>
            </header>
            <div className="body">
              <h3>AI Hospitality Hiring Platform (Paathz)</h3>
              <p>
              • Developed and enhanced a full-stack AI-powered hospitality recruitment platform using Next.js and FastAPI, connecting hospitality professionals with relevant job opportunities and helping employers discover suitable candidates. <br />
              • AI Matching Engine: Implemented intelligent candidate-job matching based on skills, experience, location, education, and other hospitality-specific profile signals to generate relevant fit scores. <br />
              • Backend Development: Built scalable FastAPI services and RESTful APIs for candidate profiles, job management, applications, matching workflows, recruiter operations, and platform data processing. <br />
              • Application & Hiring Workflow: Developed features for job discovery, AI-powered recommendations, one-slide applications, application tracking, candidate shortlisting, and employer hiring pipelines. <br />   
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Python</li>
                <li>FastAPI</li>
                <li>React</li>
                <li>AI/ML</li>
                <li>REST APIs</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}